export const DEVICE_TYPE_MOBILE = 'MOBILE';
export const DEVICE_TYPE_DESKTOP = 'DESKTOP';

export const MOBILE_RESOLUTION = 375;
export const TABLET_RESOLUTION = 768;
export const DESKTOP_RESOLUTION = 1280;
export const LARGE_RESOLUTION = 1920;

export const CONSIGNADO = 'Consignado';
export const LOAN_ORDER = 'loan-order';
export const LOAN_CONCILIATIONS = 'loan-conciliations';
export const LOAN_EMPLOYEES = 'loan-employees';
export const LOAN_BANKSLIP = 'loan-bankslip';

export enum Roles {
    ADMIN = 'admpanel_admin',
    RH = 'admpanel_hr',
    RH_CONDO = 'admpanel_hr_condo',
    RH_ADM = 'admpanel_hr_adm',
    SUPPLY = 'admpanel_supply',
    RESCISSION = 'admpanel_rescission',
    SUPPLIERS_RECOMMENDATION = 'admpanel_suppliers_recommendation'
}
